export const actionTypes = {
    SET_BUDGET_EFFECTIVENESS_DATA: 'SET_BUDGET_EFFECTIVENESS_DATA',
    SET_BUDGET_EFFECTIVENESS_CANCEL_TOKEN: 'SET_BUDGET_EFFECTIVENESS_CANCEL_TOKEN',
    IS_BUDGET_EFFECTIVENESS_FETCHING: 'IS_BUDGET_EFFECTIVENESS_FETCHING'

}